import request from '@/utils/request'

//活动轮播图
export function getActivityBanner(data) {
  return request({
    url: '/banner/listAll',
    method: 'get',
    params: data
  })
}

//活动分页查询
export function getActivityAllList(data) {
  return request({
    url: '/h5ActiveMicroStation/listPage',
    method: 'get',
    params: data
  })
}

//活动查询单个
export function getDetailActivity(data) {
  return request({
    url: '/h5ActiveMicroStation/getDetail',
    method: 'get',
    params: data
  })
}

//查询某个活动（web端）
export function getDetailActivityWeb(data) {
  return request({
    url: '/h5ActiveMicroStation/getWebDetail',
    method: 'get',
    params: data
  })
}

//获取主题
export function getThemeWork(data) {
  return request({
    url: '/pictureWork/getTheme',
    method: 'get',
    params: data
  })
}

//获取赛区
export function getSaiqu(data) {
  return request({
    url: '/pictureWork/getCompetingArea',
    method: 'get',
    params: data
  })
}

//提交作品
export function savePictureWork(data) {
  return request({
    url: '/pictureWork/save',
    method: 'post',
    data
  })
}

//提交作品one
export function savePictureWorkOne(data) {
  return request({
    url: '/pictureWork/uploadFile',
    method: 'post',
    data
  })
}

//查询所有作品分页
export function activeWinningList(data) {
  return request({
    url: '/activeWinning/ListH5ActiveWinning',
    method: 'get',
    params: data
  })
}
// 查询所有作品分页（web）/activeWinning/ListWebActiveWinning
export function activeWinningListWeb(data) {
  return request({
    url: '/activeWinning/ListWebActiveWinning',
    method: 'get',
    params: data
  })
}

//根据id查询作品
export function activeWinningById(data) {
  return request({
    url: '/activeWinning/listById',
    method: 'get',
    params: data
  })
}

//点赞
export function likeWorks(data) {
  return request({
    url: '/pictureWork/likeWorks',
    method: 'post',
    data
  })
}

//投票
export function voteWorks(data) {
  return request({
    url: '/pictureWork/voteWorks',
    method: 'post',
    data
  })
}

//判断用户是否上传过作品
export function verdictSave(data) {
  return request({
    url: '/pictureWork/verdictSave',
    method: 'post',
    data
  })
}

//公告栏
export function annouAllList(data) {
  return request({
    url: '/announcement/listAll',
    method: 'get',
    params: data
  })
}

//信息公告栏查询单个
export function textDataAll(data) {
  return request({
    url: '/announcement/listById',
    method: 'get',
    params: data
  })
}

//  新增(报名类型投稿)
export function addSignUp(data) {
  return request({
    url: '/pictureWork/signUpSave',
    method: 'post',
    data
  })
}

//判断用户是否已本人报名
export function isSignUp(data) {
  return request({
    url: '/pictureWork/listBySelf',
    method: 'get',
    params: data
  })
}

//查询代报名的作品
export function daiWorksList(data) {
  return request({
    url: '/pictureWork/listByGmat',
    method: 'get',
    params: data
  })
}

//根据主键编号查询
export function isSignUpOne(data) {
  return request({
    url: '/pictureWork/listById',
    method: 'get',
    params: data
  })
}

// 入围通知登记
export function ParticipateFrom(data) {
  return request({
    url: '/h5ActiveShortlisted/addParam',
    method: 'post',
    data
  })
}

// 获奖通知
export function ObtainFrom(data) {
  return request({
    url: '/h5ActiveWinningNotice/save',
    method: 'post',
    data
  })
}

// 查询所有活动名称activity
export function GetActivity(data) {
  return request({
    url: '/h5ActiveShortlisted/listByActiveName',
    method: 'get',
    params: data
  })
}

//查询所有赛区名称
export function GetCompetition(data) {
  return request({
    url: '/divisionManagement/listDivisionName',
    method: 'get',
    params: data
  })
}

//根据活动编号查询活动所属类型
export function listByActiveType(data) {
  return request({
    url: '/h5ActiveShortlisted/listByActiveType',
    method: 'get',
    params: data
  })
}
//消息通知
export function listAll(data) {
  return request({
    url: '/h5MessageList/listAll',
    method: 'get',
    params: data
  })
}
//根据父级编号查询d
export function listParentId(data) {
  return request({
    url: '/h5MessageList/listParentId',
    method: 'get',
    params: data
  })
}

// 机构链接统计 新增
export function linksSave(data) {
  return request({
    url: '/organizationLinks/save',
    method: 'post',
    data
  })
}

// 视频上传获取凭证
export function uploadVideo(data) {
  return request({
    url: '/pictureWork/getVoucher',
    method: 'get',
    params: data
  })
}

//
export function insertAreaName(data) {
  return request({
    url: '/h5List/insertAreaName',
    method: 'post',
    data
  })
}

// 获取ip区分国内国外
export function ipAddress(data) {
  return request({
    url: '/apiUser/ipAddress',
    method: 'get',
    params: data
  })
}

// 根据code值查询 组别
export function getCode(data) {
  return request({
    url: '/code/getCode',
    method: 'get',
    params: data
  })
}

// 刷新音/视频上传凭证
export function refreshClient(data) {
  return request({
    url: '/pictureWork/refreshClient',
    method: 'get',
    params: data
  })
}

// 生成机构二维码
export function qrcCode(data) {
  return request({
    url: '/userDivision/qrcCode',
    method: 'get',
    params: data,
    responseType: 'arraybuffer'
  })
}

// 生成H5端系统二维码
export function systemQRCode(data) {
  return request({
    url: '/h5ActiveMicroStation/systemQRCode',
    method: 'get',
    params: data,
    responseType: 'arraybuffer'
  })
}

// 根据活动编号查询奖项名称
export function listByAward(data) {
  return request({
    url: '/h5ActiveMicroStation/listByAward',
    method: 'get',
    params: data
  })
}

// 机构榜单
export function listMonthlyFocus(data) {
  return request({
    url: '/activeWinning/listMonthlyFocus',
    method: 'get',
    params: data
  })
}

// 赛区榜单
export function listDivisionMonthlyFocus(data) {
  return request({
    url: '/activeWinning/listDivisionMonthlyFocus',
    method: 'get',
    params: data
  })
}

// h5获奖作品
export function listH5ActiveAward(data) {
  return request({
    url: '/activeWinning/listH5ActiveAward',
    method: 'get',
    params: data
  })
}

// h5人气奖作品
export function listH5PopularityAward(data) {
  return request({
    url: '/activeWinning/listPopularityAward',
    method: 'get',
    params: data
  })
}
// h5获奖作品
export function listWebActiveAward(data) {
  return request({
    url: '/activeWinning/listWebActiveAward',
    method: 'get',
    params: data
  })
}
// web人气奖作品
export function listWebPopularityAward(data) {
  return request({
    url: '/activeWinning/listWebPopularityAward',
    method: 'get',
    params: data
  })
}
// 根据机构编号查询机构简介
export function organizationIntroduction(data) {
  return request({
    url: '/h5ActiveMicroStation/organizationIntroduction',
    method: 'get',
    params: data
  })
}

/**
 * 获取微信的token
 *
 */
export function getAccessToken(data) {
  return request({
    url: '/wxShare/getAccessToken',
    method: 'get',
    params: data
  })
}
